import { useIntl } from 'react-intl'

function useTripPlannerCTALabels() {
  const intl = useIntl()

  return {
    searchFlightsCopy: intl.formatMessage({
      id: 'DdjWv3siKg',
      defaultMessage: 'Search flights',
      description: 'CTA button text to search for flights in trip planner',
    }),
    viewOfferCopy: intl.formatMessage({
      id: 'hYouoC+e7T',
      defaultMessage: 'View offer',
      description: 'CTA button text to view an offer in trip planner',
    }),
    saveItemCopy: intl.formatMessage({
      id: 'yPzwVLzXbv',
      defaultMessage: 'Save to my trip',
      description: 'CTA button text to save an item to the user\u2019s trip',
    }),
    bookingDetailsCopy: intl.formatMessage({
      id: 'V3if7yCh9Y',
      defaultMessage: 'Booking details',
      description: 'CTA button text to view booking details in trip planner',
    }),
    bookNowCopy: intl.formatMessage({
      id: '+CH/zA1/oN',
      defaultMessage: 'Book now',
      description: 'CTA button text to book an offer in trip planner',
    }),
  }
}

export default useTripPlannerCTALabels
